

































// @ts-ignore
import beautify from 'xml-beautifier';
import { Action, Getter } from 'vuex-class';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {
    TableBase: () => import('@/components/table/base.vue'),
    PartOverlay: () => import('@/layouts/parts/overlay.vue'),
  },
})
export default class CafkaLogs extends Vue {
  @Getter('workspace/selected') workspace!: Workspace;

  @Action('log/index') indexLogs!: (payload: { id: number; query?: IndexQuery<Log>; workspaceId: number }) => Promise<Log[]>;

  @Prop({ required: false, default: () => [] }) logs!: Log[];

  @Prop({ required: true }) orderId!: number;

  i18n: string = 'views.logs.index';

  viewingModel: Log | null = null;

  tableLayout = {
    settings: {
      locale_path: `${this.i18n}.table`,
      max_height: 'calc(100% - 80px)',
      min_height: '100px',
      clickable: false,
    },
    structure: [
      {
        key: 'id',
        value: (model: Log) => `#${model.id}`,
        width: 75,
      },
      {
        key: 'created_at',
        value: (model: Log) => {
          // @ts-ignore
          return this.$moment(model.created_at).format('DD MMM YYYY');
        },
        width: 200,
      },
      {
        key: 'title',
        value: (model: Log) => model.title,
        width: 200,
      },
      {
        key: '',
        value: () => '<a href="#" class="font-bold text-right underline hover:no-underline">Bekijk</a>',
        sort_callback: false,
      },
      {
        key: 'status',
        value: (model: Log) => (model.data.status === 'success' ? '<span class="items-center py-4 px-8 text-14 rounded-xs bg-green text-white">success</span>' : '<span class="items-center py-4 px-8 text-14 rounded-xs bg-red text-white">failed</span>'),
        sort_callback: false,
      },
    ],
  };

  localLogs: Log[] = [];

  loadMore() {
    this.indexLogs({ id: this.orderId, query: { after: this.lastAfter, per_page: 1000 }, workspaceId: this.workspace.id });
  }

  @Watch('logs', { immediate: true })
  ordersChanged(val: Log[]) {
    this.localLogs = val;
  }

  getXml(data: any) {
    return beautify(data);
  }

  get lastAfter(): Array<string | number> {
    const total = this.logs.length;
    const last: Log = this.logs[total - 1];
    if (last && last.sort) {
      return last.sort;
    }

    return [];
  }
}
